/**
 * Shared screener storage utilities.
 * Used by both app.js (for logout/hijack) and stock_screener module.
 */

/** Keys used to store screener-related data in localStorage */
export const SCREENER_STORAGE_KEYS = [
  "stockScreenerFilters",
  "tableSettings",
  "currentScreenerName",
  "currentScreenerId",
  "currentScreenerTeam",
  // Starting universe choices the server has not acknowledged yet, keyed by User and Team. Clearing them on sign-out
  // is tidiness: a page of another User ignores and drops them, which also covers an expired session.
  "pendingStartingUniverseByTeam",
] as const;

/** Type for the storage key values */
export type ScreenerStorageKey = (typeof SCREENER_STORAGE_KEYS)[number];

/**
 * Clears all screener-related localStorage items.
 * Removes specific screener keys and all tabulator-prefixed keys.
 * Also resets the screener title element if present.
 */
export function clearScreenerStorage(): void {
  console.log("Starting storage clearing process...");

  // Remove specific screener related keys
  SCREENER_STORAGE_KEYS.forEach((key) => {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key);
      console.log(`Removed ${key}`);
    }
  });

  // Reset the header title
  const titleElement = document.getElementById("screenerTitle");
  if (titleElement) {
    titleElement.textContent = "Screener";
  }

  // Clear all tabulator- prefixed keys
  Object.keys(localStorage)
    .filter((key) => key.startsWith("tabulator-"))
    .forEach((key) => {
      localStorage.removeItem(key);
      console.log(`Removed tabulator key: ${key}`);
    });

  console.log("Storage clearing completed");
}

// Make it available globally for templates
if (typeof window !== "undefined") {
  (
    window as unknown as { clearScreenerStorage: typeof clearScreenerStorage }
  ).clearScreenerStorage = clearScreenerStorage;
}
